<!-- PROGRESS BAR -->
<insinv-progress-bar></insinv-progress-bar>
<!-- / PROGRESS BAR -->

<insinv-layout></insinv-layout>
